import { render, staticRenderFns } from "./WatchlistCount.vue?vue&type=template&id=6c981f98&scoped=true&"
import script from "./WatchlistCount.vue?vue&type=script&lang=js&"
export * from "./WatchlistCount.vue?vue&type=script&lang=js&"
import style0 from "./WatchlistCount.vue?vue&type=style&index=0&id=6c981f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c981f98",
  null
  
)

export default component.exports